import { defaultHttpClient } from '../../httpClient';
import type { GoodsReadReviewsSummaryResponse } from './types';

/**
 * - 상품 리뷰 요약 정보 조회 API
 */
export const getGoodsReviewsSummary = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsReadReviewsSummaryResponse>({
      method: 'GET',
      url: `/webview/goods/${goodsSno}/reviews/summary/`,
    })
    .then(result => result.data);
};
